import { Text } from '@chakra-ui/react'
import { motion } from 'framer-motion'

const MotionText = motion(Text)

export default MotionText
